import React from "react";
import { BRAND_NAME } from "../../common/constants";
import "./EmailInfoPage.css";

const EMAIL_TYPES = [
  {
    icon: "⏰",
    title: "Session Reminders",
    description: "Sent before your booked speaking sessions to help you prepare and join on time.",
    canDisable: true,
  },
  {
    icon: "📢",
    title: "Marketing Emails",
    description: "Offers, promotions, new plans, and special discounts tailored for you.",
    canDisable: true,
  },
  {
    icon: "📣",
    title: "Announcements",
    description: "Feature updates, platform news, and general information about our services.",
    canDisable: true,
  },
  {
    icon: "🔒",
    title: "Transactional Emails",
    description: "Booking confirmations, OTP codes, payment receipts, and account security alerts.",
    canDisable: false,
  },
];

const EmailInfoPage = () => (
  <div className="email-info-page">
    <div className="email-info-container">
      <h1 className="email-info-heading">Why am I receiving emails?</h1>
      <p className="email-info-subtitle">
        At <strong>{BRAND_NAME}</strong>, we send different types of emails to keep you informed and help you make the most of your learning journey.
      </p>

      <div className="email-info-cards">
        {EMAIL_TYPES.map((type) => (
          <div key={type.title} className="email-info-card">
            <span className="email-info-card-icon">{type.icon}</span>
            <div>
              <h3 className="email-info-card-title">{type.title}</h3>
              <p className="email-info-card-desc">{type.description}</p>
              <span className={`email-info-badge ${type.canDisable ? "optional" : "required"}`}>
                {type.canDisable ? "Can be disabled" : "Cannot be disabled"}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="email-info-manage">
        <h2>How to manage your email preferences</h2>
        <ol>
          <li>
            <strong>From the App:</strong> Go to <em>Profile → Email Preferences</em> and toggle the email types you want to receive.
          </li>
          <li>
            <strong>From an Email:</strong> Click the <em>"Unsubscribe"</em> link at the bottom of any email to instantly opt out, or click <em>"Manage Email Preferences"</em> to choose what you receive.
          </li>
          <li>
            <strong>Re-subscribe:</strong> Changed your mind? Use the <em>"Subscribe Again"</em> button on the unsubscribe page, or turn the toggle back on from your Profile.
          </li>
        </ol>
      </div>

      <div className="email-info-note">
        ℹ️ Transactional emails (booking confirmations, OTP, payments) are essential for your account security and cannot be disabled.
      </div>
    </div>
  </div>
);

export default EmailInfoPage;
